<template>
  <div class="filter-label">{{labels[paramName]}}: <slot></slot>
    <b-button
      variant="link"
      @click="remove">
      <icon name="times"></icon>
  </b-button></div>
</template>

<script>
  export default {
    name: 'filter-label',
    props: ['paramName'],
    data () {
      return {
        labels: {
          paperType: 'Paper Type',
          author: 'Author',
          keyword: 'Keyword',
          vol: 'Volume',
          issue: 'Issue',
          date: 'Date'
        }
      }
    },
    methods: {
      remove () {
        this.$emit('remove', this.paramName)
      }
    }
  }

</script>

<style scoped lang="scss">
  .filter-label{
    display: inline-block;
    border: 1px solid $grey-border;
    border-radius: 4px;
    vertical-align: middle;
    line-height: 1.25;
    color: $primary-color;
    font-family: 'Open Sans';
    margin-right: 10px;
    margin-bottom: 10px;
    text-align: center;
    padding-left: 5px;
    background-color: $white;
    button {
      color: $primary-color;;
      padding: 5px;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// FilterLabelComponent.vue?612f4952